import { Typography } from '../../../../core/components/molecules/Typography';

interface ICardContentLesson {
  teacher: string | null | undefined;
  time: string;
}

export function CardContentLesson({ teacher, time }: ICardContentLesson) {
  return (
    <div className='flex w-fit flex-row gap-lg'>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {time}
      </Typography>
      <Typography
        size='small'
        className='transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {teacher ? `Prof. ${teacher}` : ''}
      </Typography>
    </div>
  );
}
